import { render, staticRenderFns } from "./VueCardTitle.vue?vue&type=template&id=db6b343c&"
import script from "./VueCardTitle.vue?vue&type=script&lang=js&"
export * from "./VueCardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports